import React, { useState, useEffect, useContext } from "react";
import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";
import { ReadOnlyContext } from "./ReadOnlyContext";
import {
  CheckCircle,
  CirclePercent,
  CreditCard,
  FileCheck,
  Send,
  MessageSquare,
  FileSpreadsheet,
} from "lucide-react";
import GstAnalysisModal from "./GstAnalysisModal";
import CustomHeading from "./common/CustomHeading";
import FirstSection from "./FirstSection";
import SixthSection from "./SixthSection";
import IndividualKYCVerification from "./IndividualKYCVerification";
import CorporateBusinessKYC from "./Corporatebusinesskyc";
import FinancialPerformanceAnalysis from "./FinancialPerformanceAnalysis";
import FourthSection from "./FourthSection";
import SeventhSection from "./SeventhSection";
import CreditEligibilityAssessment from "./Crediteligibilityassessment";
import NinthSection from "./NinthSection";
import SCFAnalysis from "./FinancialAnalysis/SCFAnalysis";
import DBIDAnalysisNew from "./FinancialAnalysis/DBIDAnalysisNew";
import SCFAnalysisLive from "./FinancialAnalysis/SCFAnalysisLive";
import DBTLAnalysis from "./FinancialAnalysis/DBTLAnalysis";
import Loader from "../../../../../presentationals/Loader/Loader.component";
import {
  getCReditRelatedData,
  getCRifRelatedData,
  getAllCreditData,
  getCreditLoanApplicationData,
  getInitialReviewStatusByUserid,
  setInitialReviewStatusByUserid,
  getCommentListApi,
  SaveCommentListApi,
  getBureauReportData,

} from "../ActionCreator";
import Popup from "../../../../../presentationals/Popup/Popup.component";
import CustomSelect from "./common/CustomSelect";
import { ROLE } from "../../../../../../utils/Constant";
import { Visibility } from "@mui/icons-material";

const productOptions = [
  { label: "Select Option", value: "" },
  { label: "Pending", value: "PENDING" },
  { label: "Approved", value: "APPROVED" },
  { label: "Rejected", value: "REJECTED" },
];

const getStatusOptions = (statusVal) => {
  const norm = (statusVal || "").trim().toUpperCase();
  if (norm === "REJECTED") {
    return [
      { label: "Rejected", value: "REJECTED" },
      { label: "Approved", value: "APPROVED" },
    ];
  } else if (norm === "PENDING") {
    return [
      { label: "Pending", value: "PENDING" },
      { label: "Approved", value: "APPROVED" },
      { label: "Rejected", value: "REJECTED" },
    ];
  }
  return productOptions;
};

const transformComments = (apiComments) => {
  const colors = ["#0891b2", "#7c3aed", "#059669", "#dc2626", "#d97706", "#7c3aed"];

  return apiComments.map((c, i) => {
    const namePart = c.email.split("@")[0];
    const parts = namePart.split(".");
    const initials = parts.map((p) => p[0].toUpperCase()).join("").slice(0, 2);

    const date = new Date(c.createdAt);
    const time = date.toLocaleString("en-US", {
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    }).replace(",", " ·").replace(" AM", " am").replace(" PM", " pm");

    const name = c.addedBy !== "SuperUser"
      ? c.addedBy
      : parts.map((p) => p.charAt(0).toUpperCase() + p.slice(1)).join(" ");

    return {
      initials,
      color: colors[i % colors.length],
      name,
      time,
      text: c.comment,
    };
  });
};

const formatCommitteeTime = (timestamp) => {
  if (!timestamp) return "";
  const date = new Date(timestamp);
  return date.toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  }).replace(" AM", " am").replace(" PM", " pm");
};

export default function MainContent({
  tab,
  admin,
  handleTabs,
  individualKycData,
  allDetail,
  type,
  IndividualKycAPICall,
  onScroll,
  collapsed,
  scorecardOpen,
  setScorecardOpen,
}) {
  const [popup, setPopup] = useState({ show: false, popupStatus: "" });
  const [confirmModal, setConfirmModal] = useState(false);
  const [loader, setLoader] = useState(false);
  const [commentValue, setCommentValue] = useState("");
  const [financialData, setFinancialData] = useState({ crif: {}, credit: {} });
  const [bureauData, setBureauData] = useState({});
  const [creditData, setCreditData] = useState(null);
  const [loanAppData, setLoanAppData] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState("");
  const [currentStatusPrev, setCurrentStatusPrev] = useState("");
  const [gstModalOpen, setGstModalOpen] = useState(false);

  useEffect(() => {
    if (creditData?.loanSummary?.product) {
      setSelectedProduct(creditData.loanSummary.product);
    }
  }, [creditData?.loanSummary?.product]);
  const [currentStatus, setCurrentStatus] = useState("");
  const [commentList, setCommentList] = useState([]);


  const showPopup = (msg) => {
    setPopup({ show: true, popupStatus: msg });
    setTimeout(() => setPopup({ show: false, popupStatus: "" }), 3000);
  };

  const closePopup = () => {
    setPopup({ show: false, popupStatus: "" });
  };

  const removePopup = () => {
    setTimeout(() => {
      closePopup();
    }, 5000);
  };

  useEffect(() => {
    callAllApis();
    getcommentList();
  }, []);

  const getcommentList = () => {
    setLoader(true);
    getCommentListApi(allDetail?.userId, (callback) => {
      setLoader(false);
      setCommentList(transformComments(callback?.data?.comments ?? []));
    });
  };

  const callAllApis = () => {
    // financialDataList();
    getAllCreditDataByUserId();
    LoanApplicationData();
    // statusGet();
    // getBeurauData();
  };

  const LoanApplicationData = () => {
    setLoader(true);
    getCreditLoanApplicationData(allDetail?.loanId, (callback) => {
      setLoader(false);
      if (callback) {
        setLoanAppData(callback);
      }
    });
  };

  const getBeurauData = () => {
    setLoader(true);
    // getBureauReportData(
    //   "narNarayanFincap_e725a51e",
    //   (callback) => {
    //     setLoader(false);
    //     if (callback?.success === true) {
    //       setBureauData(callback);
    //     }
    //   },
    //   (error) => {
    //     setLoader(false);

    //   }
    // );
  };

  const statusGet = () => {
    // getInitialReviewStatusByUserid(allDetail?.userId, (callback) => {
    //   const raw = callback?.data?.initialReviewStatus ?? "";
    //   setCurrentStatusPrev(raw.trim().toUpperCase());
    //   setCurrentStatus(raw.trim())
    // });
  };

  const financialDataList = () => {
    // setLoader(true);
    // getCReditRelatedData(allDetail?.userId, (callback) => {
    //   setLoader(false);
    //   setFinancialData((prev) => ({
    //     ...prev,
    //     credit: callback,
    //   }));
    // });
    // getCRifRelatedData(allDetail?.userId, (callback) => {
    //   setLoader(false);
    //   setFinancialData((prev) => ({
    //     ...prev,
    //     crif: callback,
    //   }));
    // });
  };

  const getAllCreditDataByUserId = () => {
    setLoader(true);
    getAllCreditData(
      allDetail?.userId,
      (callback) => {
        setLoader(false);
        if (callback?.success && callback?.data) {
          setCreditData(callback.data);
        }
      },
      (error) => {
        setLoader(false);

      }
    );
  };

  const handleStatus = () => {
    setLoader(true);
    setInitialReviewStatusByUserid(
      allDetail?.userId,
      currentStatus,
      (callback) => {
        setLoader(false);
        if (callback?.status === 200) {
          setPopup({ show: true, popupStatus: "Status Updated Successfully!" });
        } else {
          setPopup({ show: true, popupStatus: "Error Updating Status!" });
        }
        removePopup();
        // statusGet();
      }
    );
  };



  const SaveComments = () => {
    const data = {
      comment: commentValue,
      email: admin?.emailId,
      addedBy: admin?.emailId,
    };
    setLoader(true);
    SaveCommentListApi(allDetail?.userId, data, (callback) => {
      setLoader(false);
      setCommentValue("");
      getcommentList();
      if (callback?.status === 200) {
        showPopup("Comment Added Successfully!");
      } else {
        showPopup("Error Adding Comment!");
      }
    });
  };

  const checkReadOnly = () => {
    return admin?.department === "OPERATIONS" && admin?.emailId !== "SuperUser";
  };
  const isReadOnly = checkReadOnly();
  const isReviewEnabled = admin?.emailId === "SuperUser" || admin?.department === "OPERATIONS";


  return (
    <ReadOnlyContext.Provider value={isReadOnly}>
      <>
        <style>{`
          @keyframes wogomSlideInRight {
            from {
              transform: translateX(100%);
              opacity: 0;
            }
            to {
              transform: translateX(0);
              opacity: 1;
            }
          }
          .wogom-slide-in-right {
            animation: wogomSlideInRight 0.35s cubic-bezier(0.16, 1, 0.3, 1) forwards;
          }
        `}</style>
        {loader ? <Loader /> : ""}
        {popup?.show ? (
          <Popup popupStatus={popup?.popupStatus} closePopup={closePopup} />
        ) : (
          ""
        )}

        {/* ── Confirm Status Modal ──────────────────────────────────────────── */}
        {confirmModal && (
          <div
            style={{
              position: "fixed",
              inset: 0,
              zIndex: 9999,
              background: "rgba(15,23,42,0.45)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                background: "#fff",
                borderRadius: 16,
                padding: "32px 36px",
                maxWidth: 420,
                width: "90%",
                boxShadow: "0 24px 48px rgba(15,23,42,0.18)",
                textAlign: "center",
              }}
            >
              <div
                style={{
                  width: 56,
                  height: 56,
                  borderRadius: "50%",
                  background: (currentStatus || "").toUpperCase() === "REJECTED" ? "#fee2e2" : "#dcfce7",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 16px",
                }}
              >
                <i
                  className={(currentStatus || "").toUpperCase() === "REJECTED" ? "fa fa-times-circle" : "fa fa-check-circle"}
                  style={{
                    fontSize: 28,
                    color: (currentStatus || "").toUpperCase() === "REJECTED" ? "#b91c1c" : "#15803d",
                  }}
                />
              </div>

              <h4 style={{ margin: "0 0 8px", fontSize: 18, fontWeight: 700, color: "#0f172a" }}>
                Confirm Status Update
              </h4>
              <p style={{ margin: "0 0 24px", fontSize: 14, color: "#475569", lineHeight: 1.6 }}>
                Are you sure you want to mark this application as{" "}
                <strong
                  style={{
                    color: (currentStatus || "").toUpperCase() === "REJECTED" ? "#b91c1c" : "#15803d",
                  }}
                >
                  {currentStatus || currentStatusPrev}
                </strong>
                ? This action cannot be undone.
              </p>

              <div style={{ display: "flex", gap: 12, justifyContent: "center" }}>
                <button
                  onClick={() => setConfirmModal(false)}
                  style={{
                    padding: "9px 24px",
                    borderRadius: 8,
                    border: "1px solid #cbd5e1",
                    background: "#f8fafc",
                    color: "#475569",
                    fontWeight: 600,
                    fontSize: 14,
                    cursor: "pointer",
                  }}
                >
                  Cancel
                </button>
                <button
                  onClick={() => {
                    setConfirmModal(false);
                    handleStatus();
                  }}
                  style={{
                    padding: "9px 24px",
                    borderRadius: 8,
                    border: "none",
                    background: (currentStatus || "").toUpperCase() === "REJECTED" ? "#b91c1c" : "#15803d",
                    color: "#fff",
                    fontWeight: 700,
                    fontSize: 14,
                    cursor: "pointer",
                  }}
                >
                  Yes, Confirm
                </button>
              </div>
            </div>
          </div>
        )}

        <GstAnalysisModal
          isOpen={gstModalOpen}
          onClose={() => setGstModalOpen(false)}
          initialGstin={
            creditData?.corporateKyc?.gstRegistration ||
            loanAppData?.gst ||
            loanAppData?.gstin ||
            allDetail?.gstin ||
            ""
          }
          initialUsername={creditData?.corporateKyc?.gstPortalUsername || ""}
          allDetail={allDetail}
          creditData={creditData}
          loanAppData={loanAppData}
        />



        <div 
          className="cusotm-main-content"
          style={{
            marginLeft: collapsed ? "60px" : "232px",
            // maxWidth: `calc(1800px - ${collapsed ? "60px" : "232px"})`,
            transition: "margin-left 0.2s cubic-bezier(0.4, 0, 0.2, 1), max-width 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
          }}
        >
          {/* ── Top Action Bar ─────────────────────────────────────────────────── */}
          <div
            className="cusotm-top-bar"
            style={{
              ...S.topBar,
              marginTop:
                type === "loan" &&
                  typeof window !== "undefined" &&
                  window.innerWidth < 1800
                  ? "20px"
                  : "0px",
            }}
          >
           

            <div
              className="cusotm-top-bar-right"
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                flexShrink: 0,
                justifyContent:'space-between',
                width:'100%'
              }}
            >
              
              <button
                style={{...S.ghostBtn, visibility:'hidden'}}
                onClick={() => handleTabs("StepperInfo")}
              >
                View Credit Journey
              </button>

              
<div style={{display:'flex',gap:'10px'}}>

              {/* <button style={S.outlineBtn}>
                <ArrowCircleDownIcon
                  style={{
                    width: 14,
                    height: 14,
                    strokeWidth: "1.8px",
                    flexShrink: 0,
                  }}
                />
                Export CAM
              </button> */}

              <button
                style={{
                  ...S.outlineBtn,
                  backgroundColor: gstModalOpen ? "#f0fdf4" : "#ffffff",
                  borderColor: gstModalOpen ? "#16a34a" : "#cbd5e1",
                  color: gstModalOpen ? "#15803d" : "#024e5a",
                  fontWeight: "700"
                }}
                onClick={() => setGstModalOpen(true)}
              >
                <FileSpreadsheet style={{ width: 13, height: 13, marginRight: 6 }} />
                View GST Analysis
              </button>

              <button
                style={{
                  ...S.outlineBtn,
                  backgroundColor: scorecardOpen ? "#eff6ff" : "transparent",
                  borderColor: scorecardOpen ? "#2563eb" : "#cbd5e1",
                  color: scorecardOpen ? "#2563eb" : "#475569",
                  fontWeight: "700"
                }}
                onClick={() => setScorecardOpen(!scorecardOpen)}
              >
                <MessageSquare style={{ width: 13, height: 13, marginRight: 6, width: "auto" }} />
                {scorecardOpen ? "Hide Scorecard" : "Show Scorecard"}
              </button>
</div>


            </div>
          </div>

          {/* ── Two-column body ─────────────────────────────────────────────────── */}
          <div className="row g-3" style={{ marginTop: 0, position: "relative" }}>
            <div
              className={scorecardOpen ? "col-xl-8 col-lg-8 col-md-8 col-12" : "col-12"}
              style={{
                maxHeight: "calc(100vh - 148px)",
                overflowY: "auto",
                scrollbarWidth: "thin",
                scrollbarColor: "#d1d5db transparent",
                paddingRight: 6,
                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              }}
              id="formCreditScrollContainer"
              onScroll={onScroll}
            >
              <CustomForm
                creditData={creditData}
                individualKycData={individualKycData}
                allDetail={allDetail}
                financialData={financialData}
                bureauData={bureauData}
                admin={admin}
                setLoader={setLoader}
                showPopup={showPopup}
                onRefresh={callAllApis}
                IndividualKycAPICall={IndividualKycAPICall}
                selectedProduct={selectedProduct}
                setSelectedProduct={setSelectedProduct}
                loanAppData={loanAppData}
              />
            </div>
            {scorecardOpen && (
              <div 
                className="col-xl-4 col-lg-4 col-md-4 col-12 wogom-slide-in-right"
                style={{
                  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                }}
              >
                <div className="right-sde-comps">
                  {/* ── Comments card ─────────────────────────────────────── */}
                  <div className="custom-cards">
                    <div className="comments-options">
                      <div className="comments-header">
                        <h5>Comments</h5>
                      </div>

                      <div className="custom-comment-input">
                        <input
                          type="text"
                          className="custom-commtent-box"
                          placeholder="Write a comment…"
                          value={commentValue}
                          onChange={(e) => setCommentValue(e.target.value)}
                          disabled={isReadOnly}
                        />
                        {!isReadOnly && (
                          <button className="send-btn" onClick={() => SaveComments()}>
                            <Send style={{ width: 14, height: 14 }} />
                          </button>
                        )}
                      </div>

                      <div
                        className="comment-data"
                        style={{ maxHeight: 210, overflowY: "auto" }}
                      >
                        {commentList && commentList?.length > 0 && commentList?.map((c, i) => (
                          <div key={i} className="comment-box-value">
                            <div className="avatar" style={{ background: c.color }}>
                              {c.initials}
                            </div>
                            <div className="comment-meta">
                              <div className="comment-row">
                                <span className="comment-name">{c.name}</span>
                                <span className="comment-time">{c.time}</span>
                              </div>
                              <p className="comment-text">{c.text}</p>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  {/* ── Score card ────────────────────────────────────────── */}
                  <div className="custom-cards">
                    <div className="score-card-option">
                      <div className="score-header">
                        <h5>Score Card</h5>
                      </div>

                      <div
                        className="decision-card"
                        style={{
                          background: "#f0fdf4",
                          border: "1px solid #bbf7d0",
                        }}
                      >
                        <p className="decision-label">Our Decision</p>
                        <p className="decision-value">Eligible for Approval</p>
                      </div>

                      <div
                        className="scoring-card"
                        style={{
                          background: "linear-gradient(135deg,#eff6ff,#dbeafe)",
                          border: "1px solid #bfdbfe",
                          marginBottom: 10,
                        }}
                      >
                        <div className="score-left">
                          <p className="score-value">
                            {creditData?.scoreCard?.score ?? "710"}
                          </p>
                          <p className="score-label">Score Card Value</p>
                        </div>
                        <CreditCard
                          className="score-icon"
                          style={{
                            width: 26,
                            height: 26,
                            transform: "rotate(-20deg)",
                          }}
                        />
                      </div>

                      <div
                        className="scoring-card"
                        style={{
                          background: "linear-gradient(135deg,#faf5ff,#ede9fe)",
                          border: "1px solid #ddd6fe",
                        }}
                      >
                        <div className="score-left">
                          <p className="score-value">78.2%</p>
                          <p className="score-label">FOIR Ratio</p>
                        </div>
                        <CirclePercent
                          className="score-icon"
                          style={{
                            width: 26,
                            height: 26,
                            transform: "rotate(-20deg)",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </>
    </ReadOnlyContext.Provider>
  );
}

const S = {
  topBar: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between",
    gap: 12,
    background: "#fff",
    border: "1px solid #e5e7eb",
    borderRadius: 12,
    padding: "12px 16px",
    marginBottom: 16,
    boxShadow: "0 1px 3px rgba(0,0,0,.05)",
    flexWrap: "wrap",
  },
  ghostBtn: {
    background: "none",
    border: "none",
    borderBottom: "2px solid #024e5a",
    color: "#024e5a",
    fontSize: 12,
    fontWeight: 600,
    padding: "3px 0",
    cursor: "pointer",
    whiteSpace: "nowrap",
    lineHeight: 1.5,
  },
  outlineBtn: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    background: "#f9fafb",
    color: "#374151",
    border: "1px solid #e5e7eb",
    borderRadius: 8,
    padding: "7px 14px",
    fontSize: 12,
    fontWeight: 500,
    cursor: "pointer",
    whiteSpace: "nowrap",
  },
  primaryBtn: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    background: "#024e5a",
    color: "#fff",
    border: "none",
    borderRadius: 8,
    padding: "8px 18px",
    fontSize: 12,
    fontWeight: 700,
    cursor: "pointer",
    whiteSpace: "nowrap",
    letterSpacing: ".02em",
  },
  saveBtn: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: 34,
    height: 34,
    background: "#024e5a",
    color: "#fff",
    border: "none",
    borderRadius: 8,
    cursor: "pointer",
    flexShrink: 0,
  },
};

const CustomForm = ({
  creditData,
  individualKycData,
  allDetail,
  financialData,
  bureauData,
  admin,
  setLoader,
  showPopup,
  onRefresh,
  IndividualKycAPICall,
  selectedProduct,
  setSelectedProduct,
  loanAppData,
}) => {
  const isReadOnly = useContext(ReadOnlyContext);

  return (
    <>
      <section id="loanParticular">
        <FirstSection
          allDetail={allDetail}
          initialData={creditData?.loanSummary}
          loanAppData={loanAppData}
          showPopup={showPopup}
          onRefresh={onRefresh}
          onProductChange={setSelectedProduct}
          admin={admin} setLoader={setLoader}
        />
      </section>

      <fieldset disabled={isReadOnly} style={{ border: "none", padding: 0, margin: 0 }}>
        <section id="businessKyc">
          <CorporateBusinessKYC
            allDetail={allDetail}
            initialData={creditData?.businessKyc}
            setLoader={setLoader}
            showPopup={showPopup}
            onRefresh={onRefresh}
            loanAppData={loanAppData?.data}
          />
        </section>

        <section id="individualKyc">
          <IndividualKYCVerification
            allDetail={allDetail}
            initialData={creditData?.individuals}
            individualKycData={individualKycData}
            setLoader={setLoader}
            showPopup={showPopup}
            onRefresh={onRefresh}
            IndividualKycAPICall={IndividualKycAPICall}
          />
        </section>



        
          <section id="managementProfile">
            <FourthSection
              allDetail={allDetail}
              initialData={creditData?.managementProfile}
              individualKycData={individualKycData}
              setLoader={setLoader}
              showPopup={showPopup}
              onRefresh={onRefresh}
              admin={admin}
            />
          </section>
      <FinancialPerformanceAnalysis allDetail={allDetail} setLoader={setLoader} showPopup={showPopup} onRefresh={onRefresh} />

        {/* <section style={{ marginTop: "12px" }} id="financialAnalysis">
          <CustomHeading
            title="Financial Performance Analysis"
            subtitle="All amount in (₹)"
            buttonText="Positive"
            icon={CheckCircle}
            buttonColor="#4CAF50"
            borderColor="#F5A676"
            background="#FFF5EB"
          />
          {
            selectedProduct === "DBID" || selectedProduct === "PID" || selectedProduct === "SCF" ?
              <SCFAnalysisLive
                setLoader={setLoader}
                allDetail={allDetail}
                admin={admin}
              />
              : selectedProduct === "DBTL" ? (
                <DBTLAnalysis
                  form={{ product: selectedProduct }}
                  allDetail={allDetail}
                  setLoader={setLoader}
                  financialData={financialData}
                  bureauData={bureauData}
                  admin={admin}
                  financialDataList={onRefresh}
                />
              ) : null}
        </section> */}

        <section style={{ marginTop: "12px" }} id="bankStatement">
          <SixthSection
            allDetail={allDetail}
            initialData={creditData?.bankStatement}
            financialData={financialData}
            showPopup={showPopup}
            onRefresh={onRefresh}
            admin={admin}
          />
        </section>

        {/* <section style={{ marginTop: "12px" }} id="gstProfile">
          <SeventhSection
            allDetail={allDetail}
            initialData={creditData?.gstProfile}
            financialData={financialData}
            showPopup={showPopup}
            onRefresh={onRefresh}
            admin={admin}
          />
        </section> */}

       
            <section id="creditAssesment">
              <CreditEligibilityAssessment
                allDetail={allDetail}
                initialData={creditData?.creditEligibility}
                showPopup={showPopup}
                onRefresh={onRefresh}
              />
            </section>

            <section style={{ marginTop: "12px" }} id="recomendations">
              <NinthSection
                allDetail={allDetail}
                initialData={creditData?.recommendation}
                showPopup={showPopup}
                onRefresh={onRefresh}
                admin={admin}
                initialDataFirst={creditData?.loanSummary}
                productType={selectedProduct}
              />
            </section>
         
      </fieldset>
    </>
  );
};
